import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Icon } from "@iconify/react";
import Common from "../../helper/common";
import { AmericanoTypeEnum, SearchTypeEnum } from "../../constants/appConstant";
import toast from "react-hot-toast";
import AdvanceTable from "../../components/advanceTable";

const Americanos = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({});

  useEffect(() => {
    getData();
  }, []);

  const getData = async (
    pageNumber,
    searchTerm = "",
    recordsToDisplay = null
  ) => {
    try {
      const response = await Common.ApiService.getInstance().request(
        "GetAmericanos",
        {
          pageNumber: pageNumber,
          q: searchTerm,
          recordsToDisplay,
        },
        "Post"
      );

      if (response?.data) {
        let obj = {
          ...response.data[0],
          data: response.data[0].data.map((item) => ({
            ...item,
            name: item.name ?? "-",
            type: item.type === AmericanoTypeEnum.Americano ? "Americano" : item.type === AmericanoTypeEnum.Maxicano ? "Maxicano" : "-",
            noofplayers: item.no_of_players ?? "-",
            noofcourts: item.no_of_courts ?? "-",
            // Keep original field names for API compatibility
            no_of_players: item.no_of_players,
            no_of_courts: item.no_of_courts,
          })),
        };
        setData(obj);
      }
    } catch (error) {
      toast.error(error.message || "Error fetching americanos");
    }
  };

  const columns = [
    { title: "Name", type: "text", isVisible: true, key: "name" },
    { title: "Type", type: "text", isVisible: true, key: "type" },
    { title: "Players", type: "text", isVisible: true, key: "noofplayers" },
    { title: "Courts", type: "text", isVisible: true, key: "noofcourts" },
  ];

  const actions = [
    {
      type: "view",
      onClick: (val) => navigate(`/app/americano/details?id=${val.id}`),
    },
  ];

  return (
    <>
      {data?.data && (
        <AdvanceTable
          title={"Americanos"}
          columns={columns.filter((item) => item.isVisible)}
          data={data}
          getData={getData}
          addButton={() => (
            <Button
              onClick={() => navigate("/app/americano/create")}
              className="bg-[#0C1B3A] hover:bg-[#1a2a4e] text-white border-0"
            >
              <Icon icon="heroicons:plus" className="mr-1 h-4 w-4" />
              Add New Americano
            </Button>
          )}
          showPagination
          showAddButton
          actionButtons={actions}
          search={SearchTypeEnum.Server_Search}
        />
      )}
    </>
  );
};

export default Americanos;
